import * as React from 'react';
import {
  motion,
  AnimatePresence,
} from 'framer-motion';

import {
  Lang,
  Breakpoint,

  useDimensions,

  MainContainer,
} from '@bluecurrent/web-component-lib';

import Page from '../../src/config/Page.config';

import useSanityData from '../../src/hooks/useSanityData';

import getDocument from '../../src/services/Sanity/query/getDocument';
import Legal from '../../src/services/Sanity/variables/Legal';

import LegalDocument from '../../src/components/Sections/Document/Legal';

import Head from '../../src/components/Modules/Head';

export default function TermsAndConditionsPage() {
  const { _ } = Lang.useTranslation();
  const size = useDimensions();
  const data = useSanityData(
    getDocument(Legal.termsAndConditions),
  );

  const render = [
    {
      component: <LegalDocument data={data[0]} />,
    },
  ];

  return (
    <>
      <Head
        title={_('termsConditions', { ns: 'legal' })}
        slug="/legal/terms-and-conditions"
      />
      <div
        style={{
          paddingTop: 30,
          minHeight: size.width < Breakpoint.lg
            ? Page.MIN_HEIGHT.small_screen
            : Page.MIN_HEIGHT.full_screen,
          height: 'auto',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AnimatePresence>
          {
            render.map((e, index) => (
              <motion.div
                /* eslint-disable-next-line react/no-array-index-key */
                key={index}
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: 1,
                }}
                transition={{
                  duration: 0.4,
                }}
              >
                <MainContainer>
                  <div
                    style={{
                      paddingTop: 50,
                      marginBottom: 50,
                      width: size.width < Breakpoint.lg ? '90%' : '60%',
                      marginLeft: size.width < Breakpoint.lg ? '5%' : '20%',
                      marginRight: size.width < Breakpoint.lg ? '5%' : '20%',
                    }}
                  >
                    {e.component}
                  </div>
                </MainContainer>
              </motion.div>
            ))
          }
        </AnimatePresence>
      </div>
    </>
  );
}
